import { render } from "./Checkboard.vue?vue&type=template&id=79a0f362"
import script from "./Checkboard.vue?vue&type=script&lang=js"
export * from "./Checkboard.vue?vue&type=script&lang=js"

import "./Checkboard.vue?vue&type=style&index=0&id=79a0f362&lang=css"
script.render = render

export default script